import React from 'react';
import notFound from '../upload/not-found.png'
import Header from "./Header";

const NotFound = () => {
    return (
        <>
            <Header/>
            <div className="container">
                <div className="d-flex justify-content-center">
                    <img className="w-75" src={notFound} alt="404"/>
                </div>
            </div>
        </>
    );
};

export default NotFound;